import { createContext, useContext } from "react";

export const ModalContext = createContext(null);

let _confirmImpl = async () => {
  throw new Error("ConfirmProvider is not mounted");
};

export const confirm = (opts) => _confirmImpl(opts);

export const __setConfirmImpl = (fn) => {
  _confirmImpl = fn;
};

export const useConfirm = () => {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error("useConfirm must be used within ConfirmProvider");
  return ctx.enqueueConfirm;
};
